import { render, staticRenderFns } from "./copyAdd.vue?vue&type=template&id=b58ff4d4&"
import script from "./copyAdd.vue?vue&type=script&lang=js&"
export * from "./copyAdd.vue?vue&type=script&lang=js&"
import style0 from "./copyAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports